import { Identifiable } from 'src/app/models/Identifiable';

export interface ConfigurationState extends Identifiable {
  status: ConfigurationApplicationStatus;
  configurationId: string;
  instanceId: string;
  blueprintId: string;
  solutionVersionId: string;
  deploymentClass?: string;
  testInstanceId?: string;
  applicationStartTime?: Date;
  testInstanceReadyTime?: Date;
  testConfigureDoneTime?: Date;
  testingFinishTime?: Date;
  applicationFinishTime?: Date;
  testResultsPath: string;
  configResult?: ConfigurationStateResult;
  testResult?: ConfigurationTestResult;
  codeResult?: any;
  skipTest?: any;
  manifest?: any;
  hotfix? : any;
}

export interface ConfigurationStateResult {
  status?: boolean;
  overview: ConfigurationResultsOverview;
}

export interface ConfigurationTestResult {
  status?: boolean;
  overview: ConfigurationResultsOverview;
}

export interface ConfigurationResultsOverview {
  startDate?: Date;
  endDate?: Date;
  duration?: string;
  packages: ConfigurationPackage[];
}

export interface ConfigurationPackage {
  name: string;
  description?: string;
  status: ConfigurationPackageStatus;
  startDate?: Date;
  endDate?: Date;

  success?: number;
  failure?: number;
}

export enum ConfigurationApplicationStatus {
  CONFIGURING = 'configuring',
  CONFIGURED = 'configured',
  TESTING = 'testing',
  SUCCESS = 'success',
  CONFIGURE_FAILED = 'configure_failed',
  TEST_FAILED = 'test_failed',
  VERIFYING = 'verifying',
  VERIFY_DEPLOYING = 'verify_deploying',
  VERIFY_DEPLOYED = 'verify_deployed',
  VERIFY_CONFIGURING = 'verify_configuring',
  VERIFY_CONFIGURED = 'verify_configured',
  VERIFY_CONFIGURED_FAILED = 'verify_configure_failed',
  VERIFY_TESTING = 'verify_testing',
  VERIFIED = 'verified',
  VERIFICATION_FAILED = 'verification_failed',
  FAILED = 'failed'
}

export enum ConfigurationPackageStatus {
  SUCCESS = 'success',
  FAIL = 'failed',
}

export const CONFIGURATION_STATE_DATE_FIELDS = ['applicationStartTime', 'testInstanceReadyTime',
  'testConfigureDoneTime', 'testingFinishTime', 'applicationFinishTime'];
